import { getBrandingConfig } from "./config";
import { BRANDING, type BrandingType } from "./types";

type DocumentBranding = { title: string; faviconHref?: string };

export const getEnvBranding = (): BrandingType => {
  const env = import.meta.env.VITE_ENV;

  switch (env) {
    case "armada":
      return BRANDING.ARMADA;
    case "pwc":
      return BRANDING.PWC;
    case "msquared":
    case "msquared-stage":
    case "msquared-stage-hub":
      return BRANDING.MSQUARED;
    case "icra-stage":
      return BRANDING.ICRA;
    case "icra-stage-researchassist":
      return BRANDING.ICRA_RESEARCH_ASSIST;
    default:
      return BRANDING.NEEDL;
  }
};

export const applyDocumentBranding = ({
  title,
  faviconHref,
}: DocumentBranding): void => {
  const update = () => {
    document.title = title;
    const favicon = document.getElementById("favicon") as HTMLLinkElement;
    if (favicon && faviconHref) {
      favicon.href = faviconHref;
    }
  };

  if (document.readyState !== "loading") {
    update();
  } else {
    window.addEventListener("DOMContentLoaded", update, { once: true });
  }
};

export const loadBranding = async (branding?: BrandingType): Promise<void> => {
  const activeBranding = branding || getEnvBranding();

  try {
    switch (activeBranding) {
      case BRANDING.PWC:
        await import("../styles/pwc.css");
        break;
      case BRANDING.MSQUARED:
        await import("../styles/msquared.css");
        break;
      case BRANDING.ICRA:
      case BRANDING.ICRA_RESEARCH_ASSIST:
        await import("../styles/icra.css");
        break;
      case BRANDING.ARMADA:
        await import("../styles/armada.css");
        break;
      case BRANDING.SOFTWARE_ONE:
        await import("../styles/softwareone.css");
        break;
    }

    const config = getBrandingConfig(activeBranding);
    applyDocumentBranding({ title: config.name, faviconHref: config.favicon });
  } catch (error) {
    console.error("Failed to load branding assets:", error);
    throw error;
  }
};
